<template>
    <div class="p-4">
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">新增受理單</h5>
                        <heardOptionView :options="ioptions"></heardOptionView>
                    </div>
                    <div class="card-body">
                        <formsView
                            ref="formsView"
                            :mode="'create'"
                            v-model="formData"
                        ></formsView>           
                    </div>
                </div>
            </div>
            <div class="col-6">
                <createView
                    ref="createView"
                    :mode="'create'"
                    v-model="formData"
                    :acknowledgmentList="acknowledgmentList"
                ></createView> 
            </div>
        </div>
    </div>  
    
    
</template>
<script>
import formsView from '@/views/dev/formsView.vue'
import heardOptionView from '@/components/heardOptionView.vue'
import createView from '@/views/dev/healthRecord/create.vue'

export default {
    name:'intake-create',
    data(){
        return {
            options:[{
                title:'儲存',
                btnColor:'btn-success',
                icon:'fas fa-fw fa-save',
                clickHandle:()=>{ 
                    this.save();
                }
            }],
            formData: {},
            acknowledgmentList:[],

        }
    },
    components: {
        formsView,heardOptionView,createView
    },
    methods: {
        initFromData(){
            return {
                id:null, //受理單id
                acknowledgment_serial_no:'', //受理單號
                medical_record_id:null, //病歷id
                medical_serial_no:'', //病歷編號
                species_category_id:-1, //物種類別id
                species_id:-1, //物種id
                reporter_name:'', //通報人
                reporter_type:1, //通報人類型(1:公部門,2:私人)
                same_reporter_tag:false, //同通報人 1:check
                finder:'', //拾獲人
                contact:'', //聯絡方式
                find_date: this.$shared.getCurrentDate(),  //拾獲日期
                find_time: '00:00:00',  //拾獲日期
                find_addr_city:'台東縣', //拾獲城市
                find_addr_district:'池上鄉', //拾獲區域
                find_addr_address:'', //拾獲地址
                gps_lng:'', //gps lng
                gps_lat:'', //gps lat
                rescure_reason_id:-1, //救援原因id
                rescure_reason_note:'', //救援原因備註
                attacked_type_id:-1, //動物攻擊種類id
                raising_type_id:-1, //人為原因id
                description:'', //狀況描述
                accept_date:this.$shared.getCurrentDate(), //受理日期
                update_time:'', //最近一次更新時間
                status_id:1 //受理單狀態
            }
        },
        async getAcknowledgmentList(){
            const res = await this.$api.intake.acknowledgmentFormByKeywordWithPage({
                page_size:-1
            })
            if (res.code == 200){
                let list = []
                for (let index = 0; index < res.data.list.length; index++) {
                    const element = res.data.list[index];
                    if (element.medical_id === ''){
                        list.push(element)
                    }
                }
                this.acknowledgmentList = list

                console.log('acknowledgmentList:',this.acknowledgmentList)
            }
        },
        async initView(){
            this.$store.commit('setBreadcrumb', {
                pageTitle:'受理單管理',
                path:[{
                    name:'受理單',
                    to:'/intake'
                },{
                    name:'新增受理單',
                }]
            })
            this.formData = this.initFromData()
            this.$refs.formsView.initView()
            this.getAcknowledgmentList()
        },
        async save(){
            
            if ( !this.$api.intake.checkIntakeModel(this.formData).status ){
                return alert(this.$api.intake.checkIntakeModel(this.formData).message)
            }
            let objFrom = new FormData()
            objFrom.append('serial_no',this.formData.acknowledgment_serial_no)
            objFrom.append('accept_date',this.formData.accept_date)
            objFrom.append('species_category_id',this.formData.species_category_id)
            objFrom.append('species_id', this.formData.species_id)
            objFrom.append('reporter_name', this.formData.reporter_name)
            objFrom.append('reporter_type', this.formData.reporter_type)
            objFrom.append('same_reporter_tag', this.formData.same_reporter_tag)
            //處理通報人等同拾獲人資料
            objFrom.append('finder', this.formData.same_reporter_tag ? this.formData.reporter_name : this.formData.finder)
            
            objFrom.append('contact', this.formData.contact)
            objFrom.append('find_date', `${this.formData.find_date} ${this.formData.find_time}`)
            objFrom.append('find_addr_city', this.formData.find_addr_city)
            objFrom.append('find_addr_district', this.formData.find_addr_district)
            objFrom.append('find_addr_address', this.formData.find_addr_address)
            objFrom.append('gps_lng', this.formData.gps_lng)
            objFrom.append('gps_lat', this.formData.gps_lat)
            objFrom.append('rescure_reason_id', this.formData.rescure_reason_id !== -1 ? this.formData.rescure_reason_id : '' )
            objFrom.append('rescure_reason_note', this.formData.rescure_reason_note)
            objFrom.append('attacked_type_id', this.formData.attacked_type_id !== -1 ? this.formData.attacked_type_id : '' )
            objFrom.append('raising_type_id', this.formData.raising_type_id !== -1 ? this.formData.raising_type_id : '' )

            objFrom.append('description', this.formData.description )

            objFrom.append('status_id', 1 )

            //開始呼叫API
            this.$store.state.loadingStatus = true
            const res = await this.$api.intake.importAknowledgmentForm(objFrom)
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 ){
                this.$store.state.actionResult.show({status:'fail',massage:res.msg})
                return //alert(res.msg)
            }
            this.$store.state.actionResult.show({status:'success',massage:'新增成功'})
            //初始化資料模型
            this.formData = this.initFromData()
        }
    },
    async mounted(){
        await this.initView()  
    },
    async created(){
    }
  };
</script>
